<template>
  <base-content>
    <template v-slot:sub-header>
      <sub-title-bar data-header v-if="!loading">
        <template v-slot:sub-title>
          <span class="headline"
            ><span v-html="$t('page-place.managing')"></span>: <strong>{{ place.name }}</strong></span
          ><br />
        </template>
      </sub-title-bar>
      <div style="height:80px">
        <place-menu-bar />
      </div>
      <v-breadcrumbs :items="formattedBreadcrumbsForRoute" divider="/" v-if="!loading">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item :to="item.to" :href="item.href" class="text-subtitle-2 crumb-item" :disabled="item.disabled" exact>
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
      <title-bar v-if="!loading" :actions="$route.meta.actions || null" />
    </template>
    <template v-slot:content>
      <router-view v-if="!loading" :place="place" />
      <span v-else>{{ $t('page-place.loading') }}</span>
    </template>
  </base-content>
</template>

<script>
import BaseContent from '../../../components/layout/BaseContent'
import TitleBar from '../../../components/layout/TitleBar'
import SubTitleBar from '../../../components/layout/SubTitleBar'
import PlaceMenuBar from '../components/PlaceMenuBar'
import { mapActions, mapState } from 'pinia'
import { usePlaceStore } from '@/stores'

export default {
  data: () => {
    return {
      loading: true,
    }
  },
  created () {
    // load the place data
    this.httpGetPlace({ placeId: this.placeId }).then(() => {
      this.loading = false
    })
  },
  computed: {
    ...mapState(usePlaceStore, ['findByEzObjectId']),
    placeId () {
      return this.$route.params.placeId
    },
    place () {
      return this.findByEzObjectId(this.placeId)
    },
    formattedBreadcrumbsForRoute () {
      let formatted = this.$route.meta.breadcrumbs.map((breadcrumb) => {
        let href
        if ('href' in breadcrumb) {
          href = breadcrumb.href
        } else if ('to' in breadcrumb) {
          const breadcrumbRoute = this.$router.resolve({
            name: breadcrumb.name,
            params: { placeId: this.$route.params.placeId },
          })
          href = breadcrumbRoute.href
        }

        let translatedText = (breadcrumb.titleI18NKey) ? this.$t(breadcrumb.titleI18NKey) : breadcrumb.text

        return {
          to: breadcrumb.to,
          text: translatedText,
          disabled: breadcrumb.disabled,
          href,
        }
      })
      return formatted
    },
  },
  methods: {
    ...mapActions(usePlaceStore, ['httpGetPlace']),
  },
  components: {
    BaseContent,
    TitleBar,
    SubTitleBar,
    PlaceMenuBar,
  },
}
</script>
